import { render, staticRenderFns } from "./CombinedStatements.vue?vue&type=template&id=3ff38f9e"
import script from "./CombinedStatements.vue?vue&type=script&lang=ts"
export * from "./CombinedStatements.vue?vue&type=script&lang=ts"
import style0 from "./CombinedStatements.vue?vue&type=style&index=0&id=3ff38f9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports